module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="counterBadge">'+
((__t=( counter.countText ))==null?'':_.escape(__t))+
'</span>\n';
}
return __p;
};
